import { render } from "./MessageDropdown.vue?vue&type=template&id=6a061451"
import script from "./MessageDropdown.vue?vue&type=script&lang=js"
export * from "./MessageDropdown.vue?vue&type=script&lang=js"

import "./MessageDropdown.vue?vue&type=style&index=0&id=6a061451&lang=scss"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__